type ProjectType = "all" | "web" | "mobile" | "ai" | "design"
interface Project {
    id: number
    title: string
    description: string
    image: string
    type: ProjectType[]
    technologies: string[]
    link?: string
    github?: string
  }
export const projects: Project[] = [
    {
      id: 1,
      title: "E-Commerce Platform",
      description: "A full-featured e-commerce platform with advanced product filtering and secure payment processing.",
      image: "/placeholder.svg?height=600&width=800",
      type: ["web"],
      technologies: ["Next.js", "Tailwind CSS", "Stripe", "Supabase"],
      link: "#",
      github: "#",
    },
    {
      id: 2,
      title: "AI Content Generator",
      description: "An AI-powered tool that generates marketing copy, blog posts, and social media content.",
      image: "/placeholder.svg?height=600&width=800",
      type: ["ai", "web"],
      technologies: ["React", "OpenAI API", "Node.js", "MongoDB"],
      link: "#",
    },
    {
      id: 3,
      title: "Mobile Banking App",
      description: "A secure and intuitive mobile banking application with real-time transaction tracking.",
      image: "/placeholder.svg?height=600&width=800",
      type: ["mobile"],
      technologies: ["React Native", "Redux", "Firebase", "Plaid API"],
      link: "#",
      github: "#",
    },
    {
      id: 4,
      title: "Brand Identity System",
      description:
        "A comprehensive brand identity system for a tech startup, including logo, color palette, and guidelines.",
      image: "/placeholder.svg?height=600&width=800",
      type: ["design"],
      technologies: ["Figma", "Illustrator", "Photoshop"],
      link: "#",
    },
    {
      id: 5,
      title: "AI-Powered Analytics Dashboard",
      description: "A dashboard that uses machine learning to provide predictive analytics and business insights.",
      image: "/placeholder.svg?height=600&width=800",
      type: ["ai", "web"],
      technologies: ["Vue.js", "TensorFlow.js", "D3.js", "Python"],
      link: "#",
      github: "#",
    },
    {
      id: 6,
      title: "Responsive Portfolio Website",
      description: "A modern, responsive portfolio website for a professional photographer.",
      image: "/placeholder.svg?height=600&width=800",
      type: ["web", "design"],
      technologies: ["HTML/CSS", "JavaScript", "GSAP", "Netlify"],
      link: "#",
    },
  ]